const sortArrayByLabel = (data) => {
  return data.sort((a, b) => a.label.localeCompare(b.label));
}

export {
  sortArrayByLabel
}